import { render, staticRenderFns } from "./PreviewMinimizeVideoCall.vue?vue&type=template&id=b462f7ac"
import script from "./PreviewMinimizeVideoCall.vue?vue&type=script&lang=js"
export * from "./PreviewMinimizeVideoCall.vue?vue&type=script&lang=js"
import style0 from "./PreviewMinimizeVideoCall.vue?vue&type=style&index=0&id=b462f7ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports